export default __webpack_public_path__ + "static/media/4dee0f31d8d1b786d5ff38ae59d49f611583768802301.d69ff0bd.webp";